import { useParams } from 'react-router-dom';

export const RUN_COMMAND_PERMISSION = 'RUN_COMMAND';

export const usePrivilegedEmployeeId = () => useParams<Dictionary<string>>().employeeId;

export const usePrivilegedCandidateId = () => useParams<Dictionary<string>>().candidateId as unknown as number;
